import { PageRouteProps } from "../../types";

export const pageRoutes: PageRouteProps[] = [
  {
    pathName: "/admin/page/list",
    component: "PageList",
    type: "admin",
    mode: "static",
  },
  {
    pathName: "/admin/page/add",
    component: "AddPage",
    type: "admin",
    mode: "static",
  },
  {
    pathName: "/admin/page/edit",
    component: "AddPage",
    type: "admin",
    mode: "dynamic",
  },
  {
    pathName: "/admin/trash/page/list",
    component: "PageList",
    type: "admin",
    mode: "static",
  },
];
